import { GatedContentConfiguration, GatedSheetsConfiguration } from '../types/gatedContent';

export function isGSheet(
    gatedContent: GatedContentConfiguration | GatedSheetsConfiguration
): gatedContent is GatedSheetsConfiguration {
    return (gatedContent as GatedSheetsConfiguration).gatedSheets?.length > 0;
}
